module.exports = __webpack_public_path__ + "8716b0cd7aff88ff57c96693fb019be5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-31.png
// module id = 3328
// module chunks = 0